/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Alias from 'fierry/flux/entity/alias';


export default new Alias();
